import React, { Component } from 'react';
import { G as GiphyApiInputModal } from '../giphyApiInputModal-41baafe8.js';
import 'prop-types';
import 'wix-rich-content-common';
import 'wix-rich-content-ui-components';
import '../style-inject.es-746bb8ed.js';
import './giphySelector.js';
import 'react-infinite-scroller';
import 'react-md-spinner';
import 'react-custom-scrollbars';
import '../constants.js';
import '../giphyEmptyState-aa3b5112.js';
import '../icons/PoweredByGiphy.js';
import 'classnames';
import 'lodash';
import '../types.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
class GiphyInsertModal extends Component {
  constructor() {
    super(...arguments);
    this.closeModal = () => {
      var _a, _b;
      (_b = (_a = this.props.helpers) == null ? void 0 : _a.closeModal) == null ? void 0 : _b.call(_a);
    };
    this.onGifAdd = (gif) => {
      const { componentData, pubsub, onConfirm } = this.props;
      if (onConfirm) {
        onConfirm(__spreadProps(__spreadValues({}, componentData), { gif }));
      } else {
        pubsub.update("componentData", { gif });
      }
      this.closeModal();
    };
  }
  render() {
    return /* @__PURE__ */ React.createElement(
      GiphyApiInputModal,
      __spreadValues({
        onGifAdd: this.onGifAdd,
        onCloseRequested: this.closeModal
      }, this.props)
    );
  }
}

export { GiphyInsertModal as default };
//# sourceMappingURL=giphyInsertModal.js.map
